import React, { PureComponent } from 'react';
import styled from 'styled-components';

export interface Props {
  className: string;
  alt: string;
  src: string;
}

export default class PlayerImageComponent extends PureComponent<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
        <PlayerImage className="player-image" alt="Episode image" src={`${this.props.src}`}/>
    );
  }
}

const PlayerImage = styled.img`
  width: 54px;
  height: 54px;
  padding: 5px;
  background-color: transparent;
  display: inline-block;
  min-width: 54px;
`;
